import { render, staticRenderFns } from "./workFlowYc.vue?vue&type=template&id=6049b577&scoped=true&"
import script from "./workFlowYc.vue?vue&type=script&lang=js&"
export * from "./workFlowYc.vue?vue&type=script&lang=js&"
import style0 from "./workFlowYc.vue?vue&type=style&index=0&id=6049b577&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049b577",
  null
  
)

export default component.exports